<template lang="pug">
.v-contacts.contacts(v-if="data" :id="data?.id")
	.contacts__title(v-if="data.title") {{data.title}}
	.contacts__schedule(v-if="data.schedule")
		.contacts__schedule-item(v-for="schedule in data.schedule") {{schedule.text}}
	.contacts__buttons(v-if="data.buttons")
		component.contacts__buttons-item.btn(v-for="btn in data.buttons" :is="btn.link ? 'a' : 'button'" :href="btn.link" :class="btn.className")
			v-svg-icon.btn__icon(:icon="btn.icon")
			| {{btn.text}}
	.contact__links(v-if="data.links")
		v-action.contact__link-item(v-for="link in data.links" :action="link")
			template(#icon)
				v-svg-icon.contact__link-item-icon(:icon="link.icon")
</template>

<script>

import {mapGetters} from "vuex";

export default {

	computed: {
		...mapGetters({
			getContacts: 'contacts/getContacts'
		}),

		data() {
			return this.getContacts
		}
	}
}

</script>